import React from 'react';
import Container from './styles';

import HistoryMap from './index';
import { Search } from '../pesquisa';
import { AddressProps } from 'interfaces/vehicle';

export interface HistoryMapProps {
  searchAddress?: AddressProps;
  collapsed?: boolean;
  setIsOpenModalAlerts?: (value: boolean) => void;
}

export function WrapperHistoryMap({
  searchAddress,
  setSearchAddress,
  collapsed,
}: HistoryMapProps & { setSearchAddress: (value: any) => void }) {
  return (
    <Container>
      <Search handleSetAddress={setSearchAddress} />
      <HistoryMap searchAddress={searchAddress} collapsed={collapsed} />
    </Container>
  );
}
